<app-header></app-header>

<div class="container">
    <div class="ads">
        <p>घर बैठे कमाइए<br>अभी आप घर बैठकर ऑनलाइन सट्टा खेलकर कमा सकते हैं अब आपको कहीं जाने की जरूरत नहीं है आपके ही मोबाइल में हम आपके लिए लाए हैं ऑनलाइन सट्टा है इसे ज्वाइन करने के लिए नीचे दिए गए डाउनलोड बटन पर क्लिक करे </p>
        <a href="https://play.google.com/store/apps/details?id=com.diamond.mandi">Download Now</a>
    </div>
</div>

<section class="monthchart">
    <div class="container">
        <div class="row">
            <div class="col-md-5">
                <select class="form-control" [(ngModel)]="selected_month">
                    <option value="">Choose Month</option>
                    <option *ngFor="let i of months" value="{{i.id}}">{{i.name}}</option>
                </select>
            </div>
            <div class="col-md-5">
                <select class="form-control" [(ngModel)]="selected_year">
                    <option value="">Choose Year</option>
                    <option *ngFor="let i of year" value="{{i.id}}">{{i.id}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <button (click)="getToday()" class="btn btn-primary btn-block">Choose</button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <h3>Current Month Chart</h3>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-dark" *ngIf="data.chart">
                <tr>
                    <th>Date</th>
                    <th *ngFor="let i of data.chart.game;let index=index" class="text-center">
                        <p>{{i.name.short_name}}</p>
                        <!-- <small>{{i.name.name}}</small> -->
                    </th>
                </tr>
                <tr *ngFor="let i of data.chart.array">
                    <td>{{i.date}}</td>
                    <td  class="text-center" *ngFor="let j of i.games">{{j.result?(j.result.fk_number_id<10?'0'+j.result.fk_number_id:j.result.fk_number_id):'--'}}</td>
                </tr>
            </table>
        </div>
    </div>
</section>


<app-footer></app-footer>